import { render, staticRenderFns } from "./DeleteResidentModal.vue?vue&type=template&id=52e457fd&"
import script from "./DeleteResidentModal.vue?vue&type=script&lang=js&"
export * from "./DeleteResidentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52e457fd')) {
      api.createRecord('52e457fd', component.options)
    } else {
      api.reload('52e457fd', component.options)
    }
    module.hot.accept("./DeleteResidentModal.vue?vue&type=template&id=52e457fd&", function () {
      api.rerender('52e457fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/condoMngt/component/DeleteResidentModal.vue"
export default component.exports